
//-----------Principal-----------
import Plantilla from '@/components/Audiencias/VistaMonitor/Plantilla.vue';
import VistaMonitor from '@/components/Audiencias/VistaMonitor/VistaMonitor.vue'
import VistaMonitorEstatica from '@/components/Audiencias/VistaMonitor/VistaMonitorEstatica.vue'

///Se crea la lista de paths
const AudienciasMonitor = [
  {
    path: '/AudienciasMonitor/', component: Plantilla, children:[
        { path: 'Vista', component: VistaMonitor },
        { path: 'VistaMonitor', component: VistaMonitorEstatica }
     
    
    ]
  }
];

//Se regresa la lista de paths
export default AudienciasMonitor;


// WEBPACK FOOTER //
// ./src/router/AudienciasMonitor.js